import * as React from 'react'
import { IPayment } from '@getgreenline/homi-shared'
import { InventoryLogAPI } from '@getgreenline/inventory'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'
import { LoadingAnimation } from '../../../components/LoadingAnimation'
import { InventoryLogList } from '../../../components/InventoryLogs/InventoryLogList'
import { message } from 'antd'
import { parseErrorMsg } from '../../../utilities/helpers'

interface Props {
  payment: IPayment
  inventoryLogs?: IInventoryLog[]
}

interface State {
  logs?: IInventoryLog[]
}

export class Body extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      logs: this.props.inventoryLogs,
    }
  }

  async componentDidMount() {
    await this.getInventoryLog()
  }

  componentDidUpdate(props: Props) {
    if (props.inventoryLogs && props.inventoryLogs !== this.state.logs) {
      this.setState({ logs: props.inventoryLogs })
    }
  }

  getInventoryLog = async () => {
    try {
      const { payment } = this.props
      const response = await InventoryLogAPI.getInventoryLogs(payment.companyId, {
        limit: 100,
        offset: 0,
        paymentId: payment.id,
      })

      this.setState({ logs: response.data })
    } catch (error) {
      message.error(parseErrorMsg(error) || 'An error occurred while loading inventory logs')
    }
  }

  render() {
    const { logs } = this.state

    if (!logs) {
      return (
        <div>
          <LoadingAnimation />
        </div>
      )
    } else if (logs.length === 0) {
      return (
        <div>
          <div className='text-muted'>No inventory logs</div>
        </div>
      )
    } else {
      return <InventoryLogList inventoryLogs={logs} />
    }
  }
}
